import { provideHttpClient, withXhr } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import {
  SharedConfigModule,
  TranslationConfigModule,
} from '@tnq/shared/config';
import { config } from './config';
import { appRoutes } from '../app/app-routing';
import { environment } from '../environments/environment';
import { provideAnimations } from '@angular/platform-browser/animations';
import { SUI_BUTTON_DEFAULT, SUI_FIELD_CONFIG } from '@stride-ui/components';
import { provideChunkErrorHandling } from '@move-frontend/portal-toolkit';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideHttpClient(withXhr()),
    provideRouter(appRoutes),
    { provide: SUI_BUTTON_DEFAULT, useValue: { radius: 'full', size: 'xl' } },
    {
      provide: SUI_FIELD_CONFIG,
      useValue: {
        size: 'xl',
        showErrorValidationIcon: true,
      },
    },
    provideChunkErrorHandling({
      autoReload: false,
      confirmBeforeReload: true,
      confirmMessage:
        'De website heeft een update uitgevoerd. Vernieuw de pagina om door te gaan.',
    }),
    importProvidersFrom(
      SharedConfigModule.register({ env: environment, config }),
      TranslationConfigModule.register({
        path: 'assets/i18n/',
        locales: config.languageOptions,
      }),
    ),
  ],
};
